import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyDXoeMUuRtBItV4jkp5Qvyvfh-DwPAPz2c",
  authDomain: "mine-79300.firebaseapp.com",
  projectId: "mine-79300",
  storageBucket: "mine-79300.appspot.com",
  messagingSenderId: "699664894179",
  appId: "1:699664894179:web:3712f06a91075f41815dd6"
}

const firebaseApp = firebase.initializeApp(firebaseConfig);
export const firebaseDatabase = firebaseApp.firestore();